<form [formGroup]="transformerForm">
    <div class="fdx-drop-list d-flex gap-3 align-items-start flex-wrap" cdkDropListGroup>
        @for (field of fieldArray.controls; track field) {
            <div class="d-flex gap-3 align-items-start"
                cdkDropList
                [cdkDropListData]="$index"
                [cdkDropListDisabled]="disabled"
                cdkDropListOrientation="horizontal" >
                <fdx-basic-transformer-field
                    class="bg-white fdx-expand-wrapper"
                    [class.fdx-drop-list-handle]="!disabled"
                    cdkDrag
                    [cdkDragData]="$index"
                    (cdkDragEntered)="entered($event)"
                    (cdkDragStarted)="dragging = true"
                    (cdkDragEnded)="dragging = false"
                    [cdkDragPreviewContainer]="cdkDragPreviewContainer"
                    [dragging]="isDragging"
                    [dbFields]="dbFields"
                    [fieldGroup]="controlAsFormGroup(field)"
                    (removeFieldClick)="removeFieldClick($index)"
                    [disabled]="disabled" >
                </fdx-basic-transformer-field>
                @if ($last) {
                    <button
                        type="button"
                        class="btn btn-outline-primary"
                        (click)="addNewField()"
                        [disabled]="disabled" >
                        <fa-icon [icon]="iconPlus" class="no-margin"></fa-icon>
                    </button>
                } @else {
                    <div class="my-2"><fa-icon [icon]="iconPlus"></fa-icon></div>
                }
            </div>
        }
    </div>

    @if (isLoading) {
        <div class="position-absolute top-0 w-100 h-100 bg-white opacity-50">
            <fdx-spinner class="position-absolute top-50 start-50 translate-middle"></fdx-spinner>
        </div>
    }
</form>
